import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import '../components.scss';
import { Button, Form, FormControl } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { Multiselect } from 'multiselect-react-dropdown';
import {
   postNewLeadUpWork,
   checkByJobPost,
   getAccountOwnersList,
   setNewLeadDate,
  setUpWorkData,
  setFirstMessage,
  setNewDataLead
 } from '../../redux/reduxActions/leadActions';
import {
  setLeadData, setObjectiveSelector, setSelectors, validateRequiredFields,
} from '../utils';
import { showToastError } from '../utils';
import './event.scss';
import { faBorderNone } from '@fortawesome/free-solid-svg-icons';


const NewUpworkProposalLead = (props) => {
  const [checkJobField, setCheckJobField] = useState('');
  const [checkFieldStyle, setCheckFieldStyle] = useState('form-control');
  const [animationDone, setAnimationDone] = useState(false);
  const [subject, setSubject] = useState('');
  const [funnelTypeState, setFunnelType] = useState(1);
  const [funnelStatus, setFunnelStatus] = useState(15);
  const [priority, setPriority] = useState(4);
  const [responsibleState, setResponsible] = useState(localStorage.getItem('user.id'));
  const [comment, setComment] = useState('');
  const [upWorkId, setUpWorkId] = useState('');
  const [agency, setAgency] = useState(false);
  const [accountOwner, setAccountOwner] = useState('');
  const [workTypeState, setWorkType] = useState('');
  const [workTechState, setWorkTech] = useState('');
  const [proposalTypeSelected, setProposalType] = useState('');
  const [message, setMessage] = useState('');
  const [activeButtonSave, setActiveButtonSave] = useState(1);


  const {
    isCheckJobExists, priorities, selectedLead, funnelStatuses, funnelType, workType, workTech, responsible,accountsOwner,proposalTypes,
  } = props;
  // console.log(isCheckJobExists);
  const CheckJob = async () => {
    if (!checkJobField) {
      showToastError('Check job is empty !');
      return;
    }
    setAnimationDone(true);
    // console.log(checkJobField);
    const check = await props.checkByJobPost({job_id:checkJobField});
    setAnimationDone(false);
    if(check.data) {
      setCheckFieldStyle('form-control border border-danger');
      setUpWorkId('')
    }else {
      setUpWorkId(checkJobField);
      setCheckFieldStyle('form-control border border-success');
    }
  }
  const addLead = () => {
    validateRequiredFields( priority,responsibleState);

    if (!priority|| !responsibleState) {
      return;
    }
    let workTypes = [];
    let workTech = [];
   props.postNewLeadUpWork(
      setLeadData(
        subject,
        funnelTypeState,
        funnelStatus,
        priority,
        responsibleState,
        workTypes,
	      workTech,
        comment,
      )
    );
    setActiveButtonSave(2);
  };
  const SetUpWorkData = async () => {
  	if (!upWorkId || !accountOwner) {
      showToastError('Fill in "upWorkId" and "accountOwner" required fields');
      return;
    }
  	const upWorkData = {
      id:null,
      job_id: upWorkId,
      agency,
      account_owner: parseInt(accountOwner, 10),
      lead_id: selectedLead.id,
	  };
  	const res = await props.setUpWorkData(upWorkData);
  	// console.log(res);
    props.setNewLeadDate(selectedLead.id, { upwork_record_id: res.data.id });
    setActiveButtonSave(3);
  };
  useEffect(() => {
  	props.getAccountOwnersList();
  }, []);

  const SetLeadClassification = () => {
    if (!proposalTypeSelected
		  || !priority
      || !workTypeState
		  || !workTechState
	  ) {
		  showToastError('Fill in required fields');
		  return;
	  }
    let workTypes;
    let workTech;
    if (workTypeState) {
	    workTypes = workTypeState.map((item) => item.id);
    } else {
	    workTypes = [];
    }
    if (workTechState) {
	    workTech = workTechState.map((item) => item.id);
    } else {
	    workTech = [];
    }
      const data = {
        work_type: workTypes,
        work_technology: workTech,
        proposal_type: parseInt(proposalTypeSelected, 10),
	    };
	 props.setNewLeadDate(selectedLead.id, data, props.history.push, false, '', true);
   setActiveButtonSave(4);
  };

  function setFirstMessageData() {
	  if (!message) {
		  showToastError('First message field is required!!!');
  		return;
	  }
    // console.log(message)
    props.setFirstMessage({
	    id: 256,
	    lead_id:selectedLead.id,
	    text: message
    });
    props.history.push(`/lead-list`);
    setActiveButtonSave(5);
  }

  // console.log(props)
  return (
    <div className="lead__container" style={{boxShadow: '0 0 10px #ced4da',border: '1px solid #ced4da'}}>
      <h2 style={{textAlign:'center'}}>New Upwork. Proposal Lead</h2>
      <div className="lead__container" style={{boxShadow: 'none',border: 'none'}}>
        <div className="lead__container__inner" style={{display:'flex', justifyContent:'space-between'}}>
          <p className="lead__title">Check job</p>
            <input style={{width:'80%'}}  onChange={({ target }) => setCheckJobField(target.value)} type="text" className={checkFieldStyle} />
          <div className="wrapCheckJob">
            {animationDone ? <div className="wrapLoaderCheckJob" /> : null}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => CheckJob()}
              variant="primary"
              style={{ marginLeft: 20, height: 40 }}
            >
              Check
            </Button>
          </div>
        </div>
      </div>
      <hr/>
      <div className="lead__container" style={{boxShadow: 'none',border: 'none'}}>
        <h4 style={{ color: '#383838', marginBottom: 15 }}>Create new Lead</h4>
        <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
          <p className="lead__title">
						Subject
          </p>
          <TextareaAutosize
            style={{width:'100%'}}
            maxLength={101}
            onChange={({ target }) => setSubject(target.value)}
            className="lead__textarea lead__input"
            rows={1}
            placeholder="..."
            disabled={activeButtonSave !== 1}
          />
        </div>
        <div className="lead__container__fuunel">
          <div className="lead__container__inner">
            <p className="lead__title">
              Funnel Type
              <span style={{ color: 'red' }}>*</span>
            </p>
            <Form.Group className="lead__container__inner_fuunel_type" controlId="formGridState">
              <Form.Control as="select" value={funnelTypeState}  disabled onChange={({ target }) => setFunnelType(target.value)}>
                <option key="" value="">none</option>
                {setSelectors(funnelType)}
              </Form.Control>
            </Form.Group>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
              Funnel Status
              <span style={{ color: 'red' }}>*</span>
            </p>
            <Form.Group className="lead__container__inner_fuunel_type" controlId="formGridState">
              <Form.Control as="select" value={funnelStatus}  disabled onChange={({ target }) => setFunnelStatus(target.value)}>
                <option key="" value="">none</option>
                {setSelectors(funnelStatuses)}
              </Form.Control>
            </Form.Group>
          </div>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Priority
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '100%' }} controlId="formGridState">
            <Form.Control
              as="select"
              disabled={activeButtonSave !== 1}
              value={priority}
              onChange={({ target }) => setPriority(target.value)}
            >
              <option key="" value="">none</option>
              {setObjectiveSelector(priorities)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Responsible
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '100%' }} controlId="formGridState">
            <Form.Control as="select" disabled={activeButtonSave !== 1}  value={responsibleState} onChange={({ target }) => setResponsible(target.value)}>
              <option key="" value="">none</option>
              {setObjectiveSelector(responsible)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">Description</p>
          <TextareaAutosize
            className="lead__textarea"
            style={{ width: '100%', padding: 10 }}
            rows={3}
            placeholder="..."
            disabled={activeButtonSave !== 1}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => addLead()}
            variant="primary"
            style={{ marginTop: 20 }}
            disabled={activeButtonSave !== 1}
          >
					Save
          </Button>
        </div>
      </div>
      <hr/>
      <div>
        <div className="lead__container" style={{boxShadow: 'none',border: 'none'}}>
          <h4 style={{ color: '#383838', marginBottom: 15 }}>Set UpWork Data</h4>
          <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
            <p className="lead__title">
						  UpWork job id:
              <span style={{ color: 'red' }}>*</span>
            </p>
            <TextareaAutosize
              onChange={(e) => setUpWorkId(e.target.value)}
              className="lead__textarea lead__input"
              rows={1}
              style={{ borderBottomRightRadius: 0, borderTopRightRadius: 0, width:'80%' }}
              placeholder="..."
              disabled={activeButtonSave !== 2}
              defaultValue={upWorkId}
            />
            <a
              className="input-text-button"
              href={`https://www.upwork.com/jobs/~${upWorkId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
	            Link
            </a>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
	            Account Owner:
              <span style={{ color: 'red' }}>*</span>
            </p>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <FormControl
                value={accountOwner}
                as="select"
                disabled={activeButtonSave !== 2}
                onChange={({ target }) => {
	                setAccountOwner(target.value);
							  }}
              >
                <option key="" value="">none</option>
                {
	                accountsOwner.map((item) => (
  <option key={item.id} value={item.id}>
    {item.account_owner}
  </option>
	                ))
}
               
              </FormControl>
            </Form.Group>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
						  Agency
            </p>
            <Form.Group controlId="formBasicCheckbox">
              <Form.Check  disabled={activeButtonSave !== 2} checked={agency} onChange={() => setAgency(!agency)} type="checkbox" />
            </Form.Group>
          </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
              onClick={ () => SetUpWorkData()}
                variant="primary"
                disabled={activeButtonSave !== 2}
              >
					      Save
              </Button>
            </div>
        </div>
      </div>
      <hr/>
      <div>
        <div className="lead__container" style={{boxShadow: 'none',border: 'none'}} >
          <h4 style={{ color: '#383838', marginBottom: 15 }}>Set Lead Classification</h4>
          <div className="lead__container__inner" style={{ marginBottom: 16 }}>
            <p className="lead__title">
			        Work Type
              <span style={{ color: 'red' }}>*</span>
            </p>
            <div
              style={{ width: '100%' }}
            >
              <Multiselect
                disable={activeButtonSave !== 3}
                options={workType}
                onSelect={(event) => {
				          setWorkType(event);
			          }}
                onRemove={(event) => {
	                setWorkType(event);
                }}
                displayValue="name"
              />
            </div>

          </div>
          <div className="lead__container__inner" style={{ marginBottom: 16 }}>
            <p className="lead__title">
			        Work Tech
              <span style={{ color: 'red' }}>*</span>
            </p>
            <div
              style={{ width: '100%' }}
            >
              <Multiselect
                disable={activeButtonSave !== 3}
                options={workTech}
                onSelect={(event) => {
	                setWorkTech(event);
			          }}
                onRemove={(event) => {
	                setWorkTech(event);
                }}
                displayValue="name"
              />
            </div>
          </div>
          <div className="lead__container__inner">
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <li>Have we done similar work?</li>
              <li> Affects Proposal Type</li>
              <li> Free / when are freed developers who can complete the project?</li>
              <li> The country?</li>
              <li> Payment history?</li>
              <li> How clear is the original description?</li>
            </ul>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
			        Proposal Type
              <span style={{ color: 'red' }}>*</span>
            </p>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <Form.Control
                as="select"
                disabled={activeButtonSave !== 3}
                value={proposalTypeSelected}
                onChange={({ target: { value } }) => { setProposalType(value); }}
              >
                <option key="" value="">none</option>
                {setSelectors(proposalTypes)}
              </Form.Control>
            </Form.Group>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
            onClick={() => SetLeadClassification()}
              variant="primary"
              disabled={activeButtonSave !== 3}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
      <hr/>
        <div className="lead__container" style={{boxShadow: 'none',border: 'none'}}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <h4 style={{ color: '#383838', marginBottom: 15, height: 'min-content' }}>
	            Set Lead First Message
            </h4>
          </div>
          <div className="lead__container__inner">
            <TextareaAutosize
              onChange={({ target: { value } }) => {
                setMessage(value);
              }}
              style={{width:'100%'}}
              disabled={activeButtonSave !== 4}
              rows={3}
              placeholder="..."
            />
          </div>
          <div className="lead__container__inner" style={{ display: 'flex', justifyContent: 'flex-end', marginTop:'20px' }}>
            <Button
                  onClick={ () => setFirstMessageData()}
                  variant="primary"
                  disabled={activeButtonSave !== 4}
                >
                  Save
            </Button>
          </div>
        </div>
    </div>
    
  );
};
export default connect((state) => ({
  priorities: state.skillsReducer.priorities,
  funnelStatuses: state.leadReducer.funnelStatuses,
  funnelType: state.leadReducer.funnelType,
  workType: state.leadReducer.workType,
  workTech: state.leadReducer.workTech,
  responsible: state.leadReducer.responsible,
  accountsOwner: state.leadReducer.accountsOwner,
  proposalTypes: state.leadReducer.proposalTypes,
  selectedLead: state.leadReducer.selectedLead,
  isCheckJobExists: state.leadReducer.isCheckJobExists
}), { postNewLeadUpWork, checkByJobPost, getAccountOwnersList, setUpWorkData,setNewLeadDate,setFirstMessage,setNewDataLead })(NewUpworkProposalLead);